import { useRef } from "react";
import MovingBackgroundDiv from "@/src/components/ui/movingBackgroundDiv";
import Footer from "@/src/components/footer";

const areas = [
  {
    title: "Comprehensive Cost Analysis​",
    image: "images/home/3.jpg",
  },
  {
    title: "Detailed Cost Reporting​",
    image: "/images/home/4.jpg",
  },
  {
    title: "Strategic Budget Planning​",
    image: "/images/home/5.jpg",
  },
  {
    title: "Risk Management Solutions​",
    image: "/images/home/6.jpg",
  },
];

function HomePage(props: { yScroll?: number; yScrollProgress?: number }) {
  const textRef = useRef<HTMLDivElement>(null);
  const secondRef = useRef<HTMLDivElement | null>(null);
  const movingBackgroundRefs = useRef<(HTMLDivElement | null)[]>([]);
  const scrollRefs = useRef<(HTMLDivElement | null)[]>([]);

  return (
    <>
      <div
        className="relative flex justify-center items-center"
        ref={(el) => (scrollRefs.current[0] = el)}
      >
        <img src="/images/home/1.jpg" alt="Construction Site" className="w-full object-cover max-h-96 md:max-h-[500px]" />
        <div className="absolute left-0 right-0 ml-auto mr-auto text-white text-center">
          <div className="text-xl mb-4 font-bold">
            Maximize Construction Savings Now
          </div>
          <div>
            Master cost efficiency with Wilson Wong & Associates, Hong Kong's
            leading experts in optimizing construction project savings.​
          </div>
        </div>
      </div>

      <div
        className="py-16 px-8 flex justify-center"
        ref={(el) => {
          if (el) {
            secondRef.current = el;
            scrollRefs.current[1] = el;
          }
        }}
      >
        <div className="md:w-4/5 lg:w-7/12 max-w-[800px] flex flex-col md:flex-row-reverse gap-4 py-12 md:py-24">
          <div ref={textRef}>
            <h2 className="text-2xl mb-4">Expert Project Cost Solutions HK</h2>
            <div>
              Wilson Wong & Associates deliver unparalleled precision in
              construction cost management, ensuring efficient, budget-conscious
              project outcomes across Hong Kong.​
            </div>
          </div>
          <img
            src="/images/home/2.jpg"
            alt="Construction Site"
            className="rounded-lg max-w-96 max-h-96 object-cover"
          />
        </div>
      </div>

      {areas.map((area, index) => {
        return (
          <MovingBackgroundDiv
            scroll={props.yScroll || 0}
            factor={0.5}
            style={{
              backgroundImage: `url(${area.image})`,
            }}
            key={`area-${index}`}
            ref={(el) => {
              if (el) {
                movingBackgroundRefs.current[index] = el;
                scrollRefs.current[index + 2] = el;
              }
            }}
            className="font-bold bg-fixed bg-cover bg-no-repeat full-screen flex items-center justify-center"
          >
            <span className="text-shadow text-white text-center text-2xl md:text-4xl lg:text-6xl">
              {area.title}
            </span>
          </MovingBackgroundDiv>
        );
      })}
      <Footer />
    </>
  );
}

export default HomePage;
